<template>
  <div>
    <div>
      <label>
        Кому передано<span class="field__label_required">*</span>
      </label>
    </div>
    <ForeignKeyInput
      class="modal__field_current-user"
      :record-link="recordLink"
      :value="value"
      @on-trash-click="$emit('on-delete')"
      @on-plus-click="modalIsVisible = true"
    />
    <EntityReferencesModal
      v-if="modalIsVisible"
      title="Пользователи"
      link-slug="users"
      :table-fields="modalTableFields"
      @choose="setUser"
      @close="modalIsVisible = false"
      allow-only-one-choise
      not-only-ids
    />
  </div>
</template>

<script>
import EntityReferencesModal from "@/_shared/components/modals/EntityReferencesModal";
import ForeignKeyInput from "@/_shared/components/ui/ForeignKeyInput";
import { modals } from "@/_shared/constants";
export default {
  emits: ["on-set", "on-delete"],
  props: {
    value: {
      type: Object | null,
      default: null,
    },
  },
  components: {
    EntityReferencesModal,
    ForeignKeyInput,
  },
  data() {
    return {
      modalIsVisible: false,
    };
  },
  computed: {
    recordLink() {
      if (this.value) {
        return `users/${this.value.id}`;
      }
    },
    modalTableFields() {
      return modals.users.fields;
    },
  },
  methods: {
    setUser(value) {
      this.$emit("on-set", value);
    },
  },
};
</script>

<style scoped>
.modal__field_current-user {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/stock/features/stock-movement/CurrentUserField.vue